import React from "react";
import "./Hero.css";



import oudImage from "../../assets/oud.png";
import roseImage from "../../assets/flower.png";


const Hero = () => {
  return (
    <section className="heroSection" id="home">

   

      <div className="heroContent">
        <img
          src={oudImage}
          alt="oud"
          className="heroOud"
        />

        <img
          src={roseImage}
          alt="rose"
          className="heroRose"
        />

      </div>

     

    </section>
  );
};

export default Hero;